import { Container, AppBar } from "@mui/material";
import { styled } from "@mui/material/styles";

export const LogoNav = styled((props) => <Container {...props} />)`
  width: 100%;
  max-width: unset;
`;

export const CustomNavbar = styled((props) => <AppBar {...props} />)`
  background-color: ${({ theme }) => theme.palette.secondary.main};

  & a {
    text-decoration: none;
    color: ${({ theme }) => theme.palette.secondary.contrastText};
    opacity: 0.5;
    white-space: nowrap;

    &.active {
      opacity: 1;
    }
  }

  & .MuiFormControlLabel-label {
    white-space: nowrap;
  }

  /* xs (mobile) styles only */
  ${({ theme }) => theme.breakpoints.only("sm")} {
    position: fixed;
    bottom: 25px;
    left: 15px;
    right: 15px;
    z-index: 1300;
    border-radius: 16px;
    background-color: ${props => props.theme.palette.primary.main};
    color: ${props => props.theme.palette.primary.contrastText};
    box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.06);
    border-top: 1px solid ${props => props.theme.palette.divider};

    & a {
      color: ${props => props.theme.palette.primary.contrastText};
      font-size: 1.1rem;
      opacity: 0.8;

      &.active {
        opacity: 1;
        font-weight: bold;
      }
    }
  }
`;

export const CustomFooter = styled((props) => <footer {...props} />)`
  padding: 25px 100px;
  background: ${(props) => props.background || "transparent"};

   /* xs (mobile) styles only */
  ${({ theme }) => theme.breakpoints.down("lg")} {
  padding:25px;
  }
`;